//
// HELPERS
//
// Add your function overloads here.
//

/**
 * Determines if a matching element exists in an array, given by a Predicate.
 *
 * NOTE : Taken from C#.
 *
 * @param callback Predicate
 */
Array.prototype.any = function (callback) {
  return this.filter(callback).length > 0;
}


/**
 * Remove the nth index of an array.
 *
 * NOTE : Taken from C#.
 */
Array.prototype.removeAt = function (index) {
  if (index < this.length && index >= 0) {
    this.splice(index, 1);
  }
}

/**
 * ** Fix for Safari **
 * Convert a SQL date to a JS date.
 *
 * @param date "YYYY-mm-dd" formatted date
 */
Date.fromDate = function (date) {
  return Date.fromDateTime(date + " 00:00:00");
}

/**
 * ** Fix for Safari **
 * Convert a SQL DateTime to a JS date.
 *
 * @param date "YYYY-mm-dd HH:mm:ss" formatted date
 */
Date.fromDateTime = function (date) {
  const matches = date.match(/^(\d{4}).(\d{2}).(\d{2}).(\d{2}).(\d{2}).(\d{2})$/);

  if (matches) {
    matches[2]--; // MonthIndex begins with 0 for January and ends with 11 for December so we need to decrement by one.
    return new Date(...matches.splice(1)); // Skip first item which is 'date'.
  }

  return new Date(date);
}

/**
 * Returns a user's locale formatted date/time string.
 *
 * @param component Vue component
 * @param callback Callback on another method of the date
 */
Date.prototype.toUserLocaleString = function (component, callback = this.toLocaleString.bind(this)) {
  const user = component.$store.getters['auth/user'];
  const i18n = component.$i18n;

  if (user && user.country) {
    const nationalities = component.$store.getters['nationalities/nationalities'];
    const nationality = nationalities.find(n => n.id == user.country);
    return callback(`${i18n.locale}-${nationality.code}`);
  }

  // Use current locale as fallback if user's nationality is undefined.
  return callback(i18n.locale);
}

/**
 * Returns a user's locale formatted date string.
 *
 * @param component Vue component
 */
Date.prototype.toUserLocaleDateString = function (component) {
  return this.toUserLocaleString(component, this.toLocaleDateString.bind(this));
}

/**
 * Returns a formatted string from a given array of data.
 *
 * NOTE : Taken from C#
 */
String.prototype.format = function (args) {
  let s = this;

  for (let k in args) {
    s = s.replace("{" + k + "}", args[k])
  }

  return s;
}

/**
 * Returns true if a string is empty or does only contain whitespaces.
 *
 * NOTE : Taken from C#.
 */
String.prototype.isEmptyOrWhiteSpace = function () {
  return this.trim().length == 0;
}



// WEBPACK FOOTER //
// ./resources/js/plugins/helpers.js